/*global kakao*/
import React, { useEffect } from "react";
import Header from "../Header/Header";
import { Button } from "primereact/button";
import { places } from "./places.js";

let map = null;

const imageSrc = "/images/pin.png", // 마커이미지의 주소입니다
  imageSize = new kakao.maps.Size(51, 74), // 마커이미지의 크기입니다
  imageOption = { offset: new kakao.maps.Point(26, 74) }; // 마커이미지의 옵션입니다. 마커의 좌표와 일치시킬 이미지 안에서의 좌표를 설정합니다.

// 마커 이미지 & 기본 위치
const markerImage = new kakao.maps.MarkerImage(
  imageSrc,
  imageSize,
  imageOption
);

const ShowMap = () => {
  useEffect(() => {
    loadMap();
    addMarkers();
    setCenter(37.5023936158073, 127.005860604348);
  }, []);

  const setCenter = (lat, lng) => {
    var moveLatLon = new kakao.maps.LatLng(lat, lng);
    // 지도 중심을 이동
    map.setCenter(moveLatLon);
  };

  const addMarkers = () => {
    if (places) {
      places.forEach((place) => {
        if (place.x !== 0 && place.y !== 0) {
          const markerPosition = new kakao.maps.LatLng(place.y, place.x);

          const marker = new kakao.maps.Marker({
            position: markerPosition,
            image: markerImage,
            map: map,
          });

          const iwContent = `<div style="padding:5px; width:30vw">${place.title}<br>${place.tel}</div>`;

          // 인포윈도우를 생성합니다
          const infowindow = new kakao.maps.InfoWindow({
            position: markerPosition,
            content: iwContent,
          });

          infowindow.open(map, marker);
        }
      });
    }
  };

  const getLocations = async () => {
    console.log("locations");
    places.forEach(async (place) => {
      if (place.x === 0) {
        await getLocation(place);
      }
    });

    console.log(JSON.stringify(places));
  };

  const getLocation = async (place) => {
    const geocoder = new kakao.maps.services.Geocoder();

    geocoder.addressSearch(place.address, function (result, status) {
      if (status === kakao.maps.services.Status.OK) {
        place.y = result[0].y;
        place.x = result[0].x;
      } else {
        place.y = 0;
        place.x = 0;
      }
    });

    //   if (status === kakao.maps.services.Status.OK) {
    //     var coords = new kakao.maps.LatLng(result[0].y, result[0].x);

    //     // 결과값으로 받은 위치를 마커로 표시합니다
    //     var marker = new kakao.maps.Marker({
    //       map: map,
    //       position: coords,
    //     });

    //     // 인포윈도우로 장소에 대한 설명을 표시합니다
    //     var infowindow = new kakao.maps.InfoWindow({
    //       content:
    //         '<div style="width:150px;text-align:center;padding:6px 0;">우리회사</div>',
    //     });
    //     infowindow.open(map, marker);

    //     // 지도의 중심을 결과값으로 받은 위치로 이동시킵니다
    //     map.setCenter(coords);
    //   }
    // });
  };

  const options = {
    //지도를 생성할 때 필요한 기본 옵션
    center: new kakao.maps.LatLng(37.5023936158073, 127.005860604348),
    level: 6, //지도의 레벨(확대, 축소 정도)
  };

  const loadMap = () => {
    console.log("load map");
    //지도를 담을 영역의 DOM 레퍼런스
    const container = document.getElementById("map");
    //지도 생성 및 객체 리턴
    if (map === null) {
      map = new kakao.maps.Map(container, options);
      const zoomControl = new kakao.maps.ZoomControl();
      map.addControl(zoomControl, kakao.maps.ControlPosition.RIGHT);

      kakao.maps.event.addListener(map, "zoom_changed", function () {
        // 지도의 현재 레벨을 얻어옵니다
        const level = map.getLevel();
        if (level >= 7) {
          map.setLevel(7);
        }
      });
      // kakao.maps.event.addListener(map, "bounds_changed", () => {
      //   const bounds = map.getBounds();
      //   const swLatLng = bounds.getSouthWest();
      //   const neLatLng = bounds.getNorthEast();

      //   const x1 = neLatLng.getLat();
      //   const y1 = neLatLng.getLng();
      //   const x2 = swLatLng.getLat();
      //   const y2 = swLatLng.getLng();

      //   console.log("bound changed", x1, y1, x2, y2);
      // });
    } else {
      map = null;
      map = new kakao.maps.Map(container, options);
    }
  };

  return (
    <div id="main">
      <Header title="가까운 금연센터" />
      <div className="p-grid">
        <div className="p-col-4">
          <Button
            style={{ marginTop: "5px" }}
            label="현재위치"
            onClick={async () => {
              if (navigator.geolocation) {
                await navigator.geolocation.getCurrentPosition((position) => {
                  setCenter(
                    position.coords.latitude,
                    position.coords.longitude
                  );
                });
              } else {
                console.log("NO LOCATION");
              }
            }}
          />
        </div>
      </div>
      <div
        id="map"
        style={{
          height: "80vh",
          width: "100%",
        }}
      ></div>
    </div>
  );
};

export default ShowMap;
